module.exports = __webpack_public_path__ + "static/img/Meru.729febb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/content/DergeParkhang/Meru.jpg
// module id = YwRI
// module chunks = 3